<template>
  <div class="page-common-sign">
    <div class="header">
      <div class="title">手写签名</div>
    </div>
    <div class="body">
      <div class="signature-wrap">
        <div class="signature">
          <vue-esign v-if="esignInit"
                     :class="{'is-invisible': signature.committed}"
                     ref="signature"
                     is-crop
                     v-bind="esignOpts"></vue-esign>
          <div v-if="signature.committed"
               class="preview">
            <img :src="signature.data" alt="签名"/>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <template v-if="signature.committed">
        <el-button size="large"
                   round
                   @click="handleReset">返回操作</el-button>
      </template>
      <template v-else>
        <el-button type="primary"
                   size="large"
                   round
                   :loading="committing"
                   @click="handleConfirm">{{committing ? '提交中...' : '确认签名'}}</el-button>
        <el-button size="large"
                   round
                   @click="delSignature">重新签名</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import VueEsign from 'vue-esign'
export default {
  name: 'CommonSign',
  components: {
    VueEsign
  },
  props: {
    userKey: {
      type: String,
      required: true
    },
    signKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      esignInit: false,
      esignOpts: {
        width: undefined,
        height: undefined,
        lineWidth: 6,
        bgColor: '#ffffff'
      },
      committing: false,
      signature: {
        committed: false,
        data: null
      }
    }
  },
  methods: {
    initEsign () {
      const container = this.$el.querySelector('.signature-wrap .signature')
      if (container) {
        let width = container.clientWidth || 460
        this.esignOpts.width = width
        this.esignOpts.height = Math.floor(width * 0.6)
      }
      this.esignInit = true
    },
    getSignature () {
      return new Promise((resolve, reject) => {
        let signature = this.$refs.signature
        if (signature) {
          signature.generate().then(res => resolve(res))
            .catch(() => {
              // 未签名
              resolve('')
            })
        } else {
          reject(new Error('签名组件未初始化'))
        }
      })
    },
    delSignature () {
      let signature = this.$refs.signature
      if (signature) {
        signature.reset()
      }
    },
    handleConfirm () {
      this.getSignature().then(signature => {
        if (!signature) {
          this.$message.warning('请先签名再确认')
          return
        }
        this.committing = true
        this.$ajax({
          url: `/index/common/sign/confirm/${this.userKey}/${this.signKey}`,
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            signature
          }
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.signature.data = signature
                this.$nextTick(() => {
                  this.signature.committed = true
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    handleReset () {
      this.signature.data = null
      this.$nextTick(() => {
        this.signature.committed = false
      })
    }
  },
  mounted () {
    this.initEsign()
  }
}
</script>

<style lang="scss">
  .page-common-sign {
    &>.header {
      padding: 15px 20px;
      color: #fff;
      background-color: #006de7;
      &>.title {
        font-size: 18px;
        text-align: center;
        font-weight: 500;
      }
    }
    &>.body {
      &>.signature-wrap {
        padding: 24px 16px;
        &>.signature {
          position: relative;
          border: 2px solid #dcdfe6;
          border-radius: 6px;
          overflow: hidden;
          .is-invisible {
            visibility: hidden;
          }
          .preview {
            position: absolute;
            inset: 0;
            background-color: #fff;
            z-index: 99;
            &>img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
    &>.footer {
      margin-top: 4px;
      text-align: center;
      .el-button {
        min-width: 120px;
      }
    }
  }
</style>
